module.exports = __webpack_public_path__ + "static/sport/game.56c11b2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/sport6/game.png
// module id = zb8m
// module chunks = 0